import React from 'react';
import { ShieldCheck, PersonCheck, JournalBookmark } from 'react-bootstrap-icons';

const POINTS = [
  {
    Icon: JournalBookmark,
    title: 'Guides, doesn’t dump',
    body: 'SchoolCracked is built to nudge students toward answers and critical thinking — not just paste solutions.',
  },
  {
    Icon: PersonCheck,
    title: 'Google sign-in only',
    body: 'Students use their Google account. No extra passwords for school tools they already know.',
  },
  {
    Icon: ShieldCheck,
    title: 'Their chats, their account',
    body: 'Typed chats and written transcripts of every live session are saved to the signed-in student account, so the work is reviewable.',
  },
];

export default function SafetyForParents() {
  return (
    <section className="bg-white py-14 sm:py-16">
      <div className="mx-auto max-w-landing px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-navy">For parents & teachers</p>
          <h2 className="mt-2 font-display text-3xl font-extrabold text-brand-ink sm:text-4xl">
            Designed to support learning
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {POINTS.map(({ Icon, title, body }) => (
            <div key={title} className="rounded-card border border-brand-line p-5">
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-brand-navy-100 text-brand-navy">
                <Icon size={18} />
              </div>
              <h3 className="mt-3 font-display text-lg font-bold text-brand-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-muted">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
